<script lang="ts">
	export let minHeight = 0;
	/** Pre-resolved image URL (photo / gradient / solid token image). */
	export let backgroundImgSrc: string | undefined;
	/**
	 * Layout color token (e.g. `color-primary`) used with `bg-*` when there is no
	 * pre-rendered image. Ignored when `backgroundImgSrc` is set.
	 */
	export let backgroundColorToken: string | undefined;
	/** Use the home page overlay opacity instead of the modal/login overlay. */
	export let useHomeOverlay = false;

	$: boxStyle = [
		minHeight ? `min-height: ${minHeight}px` : '',
		backgroundImgSrc ? `background-image: url("${backgroundImgSrc}")` : '',
	]
		.filter(Boolean)
		.join('; ');

	$: boxClass = [
		'preview-box',
		backgroundImgSrc || backgroundColorToken ? 'preview-box--themed' : '',
		!backgroundImgSrc && backgroundColorToken ? `bg-${backgroundColorToken}` : '',
	]
		.filter(Boolean)
		.join(' ');
</script>

<div class={boxClass} style={boxStyle || undefined}>
	<span class="preview-box-overlay" class:home-overlay={useHomeOverlay} />
	<div class="d-flex justify-content-center preview-box-content">
		<slot />
	</div>
</div>

<style>
	.preview-box {
		position: relative;
		background-image: url('/images/loginBackground.png');
		border-radius: var(--radius-big);
		padding: 24px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		overflow: hidden;
	}

	.preview-box--themed {
		background-image: none;
	}

	.preview-box-overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: var(--background-image-overlay);
		pointer-events: none;
	}

	.preview-box-overlay.home-overlay {
		background: rgba(0, 0, 0, var(--home-background-overlay-opacity, 0.35));
	}

	.preview-box-content {
		position: relative;
		z-index: 1;
		width: 100%;
	}
</style>
